import {
  postDownloadArticle,
  type DownloadRequest,
} from '@/features/analyze/api/downloadArticles';
import { useArticleSearchCondition } from '@/features/analyze/hooks/useArticleSearchCondition';
import { format } from '@formkit/tempo';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

const buildFileName = () => {
  const now = new Date();
  return `rulewatcher_articles_${format(now, 'YYYY-MM-DD_HHmmss')}.csv`;
};

const downloadFile = (data: Blob) => {
  const blob = new Blob([data]);
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = buildFileName();

  document.body.appendChild(link);
  link.click();

  // クリーンアップ
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

export const useDownloadArticles = () => {
  const searchCondition = useArticleSearchCondition();
  const [currentOffset, setCurrentOffset] = useState(0);

  const mutationFn = ({ downloadCount }: { downloadCount: number }) => {
    const request: DownloadRequest = {
      condition: searchCondition,
      limit: downloadCount,
      offset: currentOffset,
    };

    return postDownloadArticle(request);
  };

  const mutation = useMutation({
    mutationKey: ['downloadArticles'],
    mutationFn,
    onSuccess: (data, variables) => {
      const { downloadCount } = variables;
      // ダウンロードが失敗した時にユーザーがやり直せるように、成功時にのみ offset を更新する
      setCurrentOffset((prev) => prev + downloadCount);
      downloadFile(data);
    },
  });

  return {
    mutation,
    currentOffset,
  };
};
